import { LEVEL } from '@const/websocketMessage.constants';
import { HostCfgDTO } from './hostCfgResponse.dto';
import { ITestSection } from './microserviceResponse.dto';

export type Level = typeof LEVEL[keyof typeof LEVEL];

// deprecated
export interface AlertWS {
  header: string;
  url: string;
  text: string;
  level: Level;
  timestamp: number;
}

export interface WsConTestEventsFromServer {
  replySection: (section: ITestSection) => void;
}

export interface WsConTestEventsFromClient {
  testCfg: (cfg: HostCfgDTO) => void;
}

export interface WsReloadEventsFromServer {
  message: (msg: WebsocketMessage) => void;
}

/**
 * Socket.IO namespaces. All gateways share one engine.io endpoint on the default
 * `/socket.io` path so cluster-wide sticky routing needs a single rule — see server StickySession.ts.
 */
export const WS_NS_RELOAD = '/reload';
export const WS_NS_MSTEST = '/mstest';
export const WS_NS_CONFIMPORT = '/confimport';

/**
 * engine.io endpoint every namespace shares. The server binds it unprefixed; the client
 * prepends the public-URL prefix, since socket.io-client reads a URL path as the namespace.
 */
export const SOCKET_IO_PATH = '/socket.io';

export const WS_TOKEN_PARAM = 'wsToken';

/** The payload each event on the reload namespace carries. */
interface WebsocketDataOf {
  reload: WebsocketReloadData;
  license: WebsocketLicenseData;
  grafana: WebsocketGrafanaData;
  llm: WebsocketLLMData;
}

export type WebsocketEvent = keyof WebsocketDataOf;

/** A union rather than a pair of independent fields, so `data` has to match `event`. */
export type WebsocketMessage<E extends WebsocketEvent = WebsocketEvent> = {
  [K in E]: { event: K; data: WebsocketDataOf[K]; };
}[E];

export interface WebsocketReloadData {
  type: 'health-status' | 'menu' | 'dashboard' | 'session' | 'top-menu';
}

export interface WebsocketLicenseData {
  status: 'warn' | 'error' | 'ok';
  type: 'license';
}

export interface WebsocketGrafanaData {
  active: boolean;
}

export interface WebsocketSessionTimeoutData {
  timeout: number;
}

export interface WebsocketLLMData {
  active: boolean;
}
